import { html } from "../../base/_utils";

export default function staffModal(member, path) {
    return html`
        <div id="${member.id}-modal" class="modal staff-modal fade" tabindex="-1" aria-labelledby="${member.id}-modalLabel" aria-modal="true" aria-hidden="true" role="dialog">
            <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 id="${member.id}-modalLabel" class="modal-title staff-name">${member.name}</h4>
                        <button class="btn-close btn-close-primary ms-auto" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="container p-0">
                            <div class="row justify-content-between">
                                <div class="col-lg-8 staff-bio order-2 order-lg-1 mt-3 mt-lg-0">${member.bio}</div>
                                <div class="col-lg-4 modal-image order-1 order-lg-2">
                                    <img class="img-fluid staff-image w-100 shadow" src="${path}${member.image}" alt="${member.name} headshot" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer bg-primary text-white">
                        <p class="mb-0  w-100">
                            <strong class="staff-title">${member.title}</strong><br />
                            <a class="staff-email text-secondary d-block w-fit-content link-underline-secondary link-underline-opacity-0-hover" href="mailto:${member.email}">${member.email}</a>
                            <a class="staff-phone text-secondary d-block w-fit-content link-underline-secondary link-underline-opacity-0-hover" href="tel:+1${member.phone}">${member.phone}</a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    `;
}
